import { SailthruPersonalizationEngine } from 'components/widget/sailthru/sailthru-personalization-engine'
export default SailthruPersonalizationEngine
